/** Mark axios config so I18nProvider does not show site-wide error banner (admin forms handle errors). */
export const SKIP_GLOBAL_ERROR = "skipGlobalError";

export function withSkipGlobalError(config = {}) {
  return { ...config, [SKIP_GLOBAL_ERROR]: true };
}

export function isSkipGlobalError(config) {
  if (!config) return false;
  if (config[SKIP_GLOBAL_ERROR]) return true;
  const url = String(config.url || "");
  return (
    url.includes("/admin/users") ||
    url.includes("/admin/approvals") ||
    url.includes("/admin/bootstrap") ||
    url.includes("/sacred-library/") ||
    url.includes("/pages") ||
    url.includes("/content/") ||
    url.includes("/i18n/") ||
    url.includes("/tattva") ||
    url.includes("/admin/tattva") ||
    url.includes("/admin/notifications") ||
    url.includes("/alerts/") ||
    url.includes("/user/profile") ||
    url.includes("/alerts/debug") ||
    url.includes("/admin/alerts/") ||
    url.includes("/acharya/") ||
    url.includes("/journey/") ||
    url.includes("/auth/refresh") ||
    url.includes("/auth/signup") ||
    url.includes("/auth/register") ||
    url.includes("/auth/request-reset") ||
    url.includes("/auth/forgot") ||
    url.includes("/auth/resend-verification")
  );
}

/** Session restore — 401 is expected when token expired; do not show site-wide banner. */
export function isAuthSessionRequest(config) {
  const url = String(config?.url || "");
  const method = String(config?.method || "get").toLowerCase();
  return method === "get" && (url.includes("/user") || url.endsWith("/user"));
}
